(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["diagnox-final-cta-banner"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const bannerButton = document.querySelector('.diagnox-final-cta-banner__button');
  const addButton = document.querySelector('.diagnox-product-hero__add');

  if (bannerButton && addButton) {
    bannerButton.addEventListener('click', function (event) {
      event.preventDefault();

      addButton.click();
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
